import { get, post, put } from '../Services/http';
import { catchError } from './Error.action';
import { receive } from './Cart.action';
import {
  SAVED_CART_LIST_RECEIVE,
  SAVED_CART_OPEN,
  SAVED_CART_CLOSE,
  SAVED_CART_PRODUCT_SELECTION,
  SAVED_CART_PRODUCT_DESELECTION,
  UPDATE_CART_ROW_STATUS,
  UPDATE_CART_ROW_INIT_STATUS,
  SAVED_CART_LIST_ADD_TO_CART_CLEAR,
  DELETE_CART,
  UPDATE_CART_NAME,
  SAVED_CART_LOAD_ERROR,
} from '../constants';
import { googleAnalyticsAddToCart } from '../Services/googleAnalytics'

const apiBaseUrl = '/api/savedcart';

export const open = (id) => ({
  type: SAVED_CART_OPEN,
  payload: id,
});

export const close = () => ({
  type: SAVED_CART_CLOSE,
});

export const selectSavedCartProduct = (id) => ({
  type: SAVED_CART_PRODUCT_SELECTION,
  payload: id,
});

export const deselectSavedCartProduct = (id) => ({
  type: SAVED_CART_PRODUCT_DESELECTION,
  payload: id,
});

export const updateCartRowStatus = (id, rowStatus) => ({
  type: UPDATE_CART_ROW_STATUS,
  payload: { id, rowStatus },
});

export const updateCartRowInitStatus = (cartRowStatusList) => ({
  type: UPDATE_CART_ROW_INIT_STATUS,
  payload: { cartRowStatusList },
});

export const receiveSelectedCart = (carts, selectedOrderRowList) => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    selectedCart: carts,
    loadingStatus: 'Completed',
    selectedOrderRowList,
  },
});

const hideShowButton = () => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    showUpdateButton: false,
  },
});

export const clearSelectedCart = () => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    selectedCart: {},
    loadingStatus: 'Loading',
    selectedOrderRowList: [],
  },
});

export const clearCartRowStatusList = () => ({
  type: SAVED_CART_LIST_ADD_TO_CART_CLEAR,
  payload: {
    cartRowStatusList: [],
  },
});

export const deleteCart = (cartId) => ({
  type: DELETE_CART,
  payload: { cartId },
});

export const updateCartName = (cartId, name) => ({
  type: UPDATE_CART_NAME,
  payload: { cartId, name },
});

const receiveCarts = (status, carts) => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    savedCarts: carts,
    loadingStatus: 'Completed',
    showUpdateButton: status,
  },
});

const receiveCartLists = (status, carts) => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    ...carts,
    loadingStatus: 'Completed',
    showUpdateButton: status,
  },
});

const clearReceiveCarts = () => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    savedCarts: [],
    loadingStatus: 'Loading',
  },
});

const setUserId = (value) => ({
  type: SAVED_CART_LIST_RECEIVE,
  payload: {
    selectedUserId: value,
  },
});

export const loadError = (error) => ({
  type: SAVED_CART_LOAD_ERROR,
  payload: {
    error,
  },
});

export const updateSavedCartRowAddStatus =
  (message) => (dispatch, getState) => {
    dispatch(updateCartRowStatus(message.savedCartOrderRowId, message.error ? 3 : 2));
  };

export const setReceiveSelectedCart = (carts) => (dispatch, getState) => {
  const orderRows = carts.orderRows || [];

  const selectedOrderRowList = orderRows.filter((row) => row.rowSystemId && row.isPublished === true && row.isHideProductPurchase === false)
                                        .map((row) => row.rowSystemId);

  dispatch(receiveSelectedCart(carts, selectedOrderRowList));
};

export const updateCartRowInitAddStatus =
  (selectedOrderRowList) => (dispatch, getState) => {
    const cartRowStatusList = selectedOrderRowList.map((orderRowId) => ({
      id: orderRowId,
      rowStatus: 1,
    }));
    dispatch(updateCartRowInitStatus(cartRowStatusList));
  };

export const setShowButton = (status, savedCarts) => (dispatch) => {
  let arrayItem = [];
  savedCarts.map((cart, index) => {
    cart.isDelete = false;
    arrayItem.push(cart);
  });
  dispatch(receiveCarts(status, arrayItem));
};

export const updateSavedCart = (savedCarts) => (dispatch) => {
  dispatch(hideShowButton());
  return put(apiBaseUrl + '/update', savedCarts)
    .then((response) => {
      dispatch(receiveCarts(false, savedCarts.filter((cart) => !cart.isDelete)));
    })
    .catch((ex) =>
      dispatch(
        catchError(ex, (error) => {
          return loadError(error);
        })
      )
    );
};

export const addToCart =
  (selectedOrderId, selectedOrderRowList, isListPage = false) => (dispatch) => {
    if (!isListPage) {
      dispatch(clearCartRowStatusList());
      dispatch(updateCartRowInitAddStatus(selectedOrderRowList));
    }
    return post('/api/savedcart/addtocart', {
      selectedOrderId,
      selectedOrderRowList,
    })
      .then((response) => response.json())
      .then((cart) => {
        renderGoogleAnalytics(cart.orderRows, selectedOrderRowList);
        dispatch(receive({ ...cart }));
      })
      .catch((ex) =>
        dispatch(catchError(ex, (error) => { return loadError(error); }))
      );
  };

export const getSelectedCart = (orderId) => (dispatch) => {
  if (orderId) {
    dispatch(clearSelectedCart());
    return get(apiBaseUrl + '/order/' + orderId)
      .then((response) => response.json())
      .then((data) => {
        dispatch(setReceiveSelectedCart(data));
        dispatch(receive({ ...data }));
      })
      .catch((ex) =>
        dispatch(catchError(ex, (error) => { return loadError(error); }))
      );
  }
};

export const getUserCarts = (userId) => (dispatch) => {
  dispatch(clearReceiveCarts());
  dispatch(hideShowButton());
  dispatch(setUserId(userId));
  if (!userId) {
    dispatch(receiveCarts(false, []));
    return;
  }
  return get(apiBaseUrl + '/user/' + userId)
    .then((response) => response.json())
    .then((data) => dispatch(receiveCarts(false, data)))
    .catch((ex) =>
      dispatch(
        catchError(ex, (error) => {
          return loadError(error);
        })
      )
    );
};

export const updateSavedCartName =
  (SelectedOrderId, SelectedOrderName) => (dispatch) => {
    return put(apiBaseUrl + '/titleupdate/', {
      SelectedOrderId,
      SelectedOrderName,
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(updateCartName(SelectedOrderId, SelectedOrderName));
      })
      .catch((ex) =>
        dispatch(
          catchError(ex, (error) => {
            return loadError(error);
          })
        )
      );
  };

export const getSavedCartsList = (userId) => (dispatch) => {
  dispatch(clearSelectedCart());
  return get(apiBaseUrl)
    .then((response) => response.json())
    .then((data) => dispatch(receiveCartLists(false, data)))
    .catch((ex) =>
      dispatch(
        catchError(ex, (error) => {
          return loadError(error);
        })
      )
    );
};

const renderGoogleAnalytics = (orderRows, selectedOrderRowList) => {

  let matchedRows = orderRows.filter(orderRow => selectedOrderRowList.includes(orderRow.rowSystemId));

  if (matchedRows && matchedRows.length > 0) {
    const products = matchedRows.map(row => ({
      name: row.name,
      id: row.articleNumber,
      category: row.breadcrumbs,
      campaignProduct: row.isCampaignProduct,
    }));

    googleAnalyticsAddToCart(products)
  }

};